import { node_observable_component } from 'common/util/ComponentDecorator';
import LinkUtil from "common/util/LinkUtil";

@node_observable_component
export default class MyOrderPinForm {
	static classname = 'my-order-pin-form';

	constructor($form) {
		this.$form = $form;

		this.init();
		this.bindEvents();
	}

	init = () => {
		this.is_disabled_buttons = true;
	};

	bindEvents = () => {
		this.$pin_input.on('input', this.handlePinInput);
		this.$form.on('submit', (e) => {
			e.preventDefault();
			const url = LinkUtil.create(this.$form.attr('action') || '').toString();
			const data = this.$form.serializeArray();
			$.ajax({
				url: url,
				data: data
			}).then((response) => {
				console.log(response);
				const $response = $(response);
				this.$form.closest('.my').replaceWith($response);
			});
		});
	};

	get $buttons() {
		return this.$form.find('.my-order-pin-form__btn');
	}

	set is_disabled_buttons(state) {
		this.$buttons.each(function () {
			const $button = $(this);

			$button.toggleClass('btn--disabled', state);
		})
	}

	get $pin_input() {
		return this.$form.find('input[name="pin"]');
	}

	handlePinInput = () => {
		this.is_disabled_buttons = !(this.$pin_input.val() !== '' && this.$pin_input.val().match(/^\d{4}$/));
	};



}
